import { NX_PUBLIC_DASHBOARD_URL, NX_ENV } from './env-from-process';
export var environment = {
    env: NX_ENV !== null && NX_ENV !== void 0 ? NX_ENV : 'production',
    production: true,
    apiUrl: 'https://authn.zephyrcloud.app',
    dashboardUrl: NX_PUBLIC_DASHBOARD_URL !== null && NX_PUBLIC_DASHBOARD_URL !== void 0 ? NX_PUBLIC_DASHBOARD_URL : 'https://app.zephyr-cloud.io'
};
